import * as Sentry from '@sentry/react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { getTwilioIntegrationDetails } from 'api/admin/businesses/twilioIntegration';
import { GetTwilioIntegrationDetailsResponse } from 'types/twilio/twilioIntegrationDetails';
import { TwilioQueryKeys } from 'constants/twilio/twilioQueryKeys';

export const useInvalidateTwilioIntegration = (businessId: number) => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries([TwilioQueryKeys.INTEGRATION_DETAILS, businessId]);
};

export const useGetTwilioIntegration = (businessId: number) => {
  const { isLoading, error, data, refetch } = useQuery<
    unknown,
    AxiosError<{ error: string }>,
    GetTwilioIntegrationDetailsResponse
  >({
    queryKey: [TwilioQueryKeys.INTEGRATION_DETAILS, businessId],
    queryFn: async () => {
      const response = await getTwilioIntegrationDetails(businessId);
      
      return response.data;
    },
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ??
          'An error occurred while fetching Twilio integration details',
        {
          icon: '❌',
        },
      );
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
